module.exports = __webpack_public_path__ + "img/calendar-resume.97c9c364.svg";